<template>
    <div class="kanban-container" ref="kanban">
        <div style="height:60px;display:flex;">

            <img style="height:30px;margin: 15px 70px 15px 90px;" :src="require('../../assets/p-kb-1.png')" />
            <span class="production-kb-header">【{{ companyName }}】生产实时看板</span>
            <img style="height:30px;margin-top:15px;margin-left: 75px;" :src="require('../../assets/p-kb-1.png')" />

        </div>

        <div style="overflow: auto;height: 570px;">
            <table class="kb-table">
                <tr>
                    <td style="width: 15px;max-width: 15px;">设备编号</td>
                    <!-- <td style="width: 45px;max-width: 45px;">订单编号</td> -->
                    <td style="width: 60px;max-width: 60px;">产品名称</td>
                    <td style="width: 15px;max-width: 15px;">业务代号</td>

                    <td style="width: 30px;max-width: 30px;">客户</td>

                    <td style="width: 40px; max-width: 40px;">备注</td>

                    <td style="width: 24px;max-width: 24px;">订单数</td>
                    <td style="width: 25px;max-width: 25px;">完成数</td>

                    <td style="width: 30px;max-width: 30px;">完成率</td>
                    <td style="width: 10px;max-width: 10px;">首检</td>
                    <td style="width: 15px;max-width: 15px;">标准周期</td>
                    <td style="width: 15px;max-width: 15px;">实际周期</td>

                    <td style="width: 28px;max-width: 28px;">上机时间</td>
                    <td style="width: 15px;max-width: 15px;">设备状态</td>

                    <td style="width: 30px;max-width: 30px;">排队1</td>
                    <td style="width: 30px;max-width: 30px;">排队2</td>
                    <td style="width: 23px;max-width: 23px;">剩余时间</td>
                    <!-- <td style="width: 40px;max-width: 40px;">排队3</td> -->
                </tr>

                <tr v-for="(item, index) in productionKanbanList" :key="index">

                    <td>{{ item.equipmentCode }}</td>
                    <!-- <td>{{ item.orderCode }}</td> -->
                    <td style="text-align:left;padding-left:5px;white-space: nowrap;overflow: hidden;">
                        {{ item.productName }}
                    </td>
                    <td>{{ item.salesman }}</td>
                    <td>{{ item.customer }}</td>

                    <td>{{ item.remark }}</td>
                    <td>{{ item.orderCount }}</td>
                    <td>{{ item.completeCount }}</td>
                    <td>
                        <el-progress :text-inside="true" :stroke-width="24"
                            :percentage="toFloat3(item.completeCount / item.orderCount)" status="success"></el-progress>
                    </td>
                    <td>{{ item.inspectionStatus }}</td>
                    <td>{{ item.takeTime }}</td>

                    <td
                        :class="(item.actualTime >= 1200 || item.actualTime == null) && item.statusStr == '生产' ? 'kanban-td-y' : item.actualTime > item.takeTime + 5 ? 'kanban-td-r' : 'kanban-td-g'">
                        {{ item.actualTime }}</td>

                    <td>{{ item.startTime }}</td>

                    <td
                        :class="item.statusStr == '待机' ? 'kanban-td-o' : item.statusStr == '生产' ? 'kanban-td-g' : 'kanban-td-r'">
                        {{ item.statusStr }}</td>

                    <td style="text-align:left;padding-left:5px;white-space: nowrap;overflow: hidden;">
                        {{ item.productOne }}
                    </td>
                    <td style="text-align:left;padding-left:5px;white-space: nowrap;overflow: hidden;">
                        {{ item.productTwo }}
                    </td>
                    <td>{{ item.remainder == null ? '' : item.remainder + 'H' }}</td>
                    <!-- <td>{{ item.productProcessThree }}</td> -->
                </tr>

            </table>

            <div style="height: 10px;"></div>
        </div>

        <div style="height: 10px;"></div>

        <div style="height: 10px;"></div>

        <div style="position: absolute;right: 30px;bottom: 5px;">
            <i class="el-icon-full-screen" @click="fullScreen" style="color:orange"></i>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            companyId: '',
            companyName: '中国制造',

            productionKanbanList: [],

            index: 0,
            statusSearch: 0,

            pageIndex: 0,
            pageNum: 18,
            total: 0,
            pageCount: 0
        }
    },
    methods: {
        getAll() {

            this.$axios({
                method: "get",
                url: "/shiro/product/kanban/tv?companyId=" + this.companyId + '&pageIndex=' + this.pageIndex,
                data: {},
                headers: {}
            }).then(result => {

                const data = result.data

                if (data.status === 202) {
                    this.$notify({
                        title: '重要提示',
                        message: data.msg,
                        duration: 0
                    });
                    return
                }

                this.productionKanbanList = data.data

                this.total = this.productionKanbanList[0].total

                for (let i in this.productionKanbanList) {
                    if (this.productionKanbanList[i].startTime) {

                        this.productionKanbanList[i].startTime = this.$moment(this.productionKanbanList[i].startTime).format("MM-DD")

                        if (this.productionKanbanList[i].startTime == '01-01') {
                            this.productionKanbanList[i].startTime = ''
                        }
                    }

                    // if (this.productionKanbanList[i].equipmentStatus == 1) {
                    //     this.productionKanbanList[i].equipmentStatus = '待机'
                    // } else if (this.productionKanbanList[i].equipmentStatus == 2) {
                    //     this.productionKanbanList[i].equipmentStatus = '生产'
                    // } else if (this.productionKanbanList[i].equipmentStatus == 3) {
                    //     this.productionKanbanList[i].equipmentStatus = '检修'
                    // } else if (this.productionKanbanList[i].equipmentStatus == 4) {
                    //     this.productionKanbanList[i].equipmentStatus = '暂停'
                    // } else {
                    //     this.productionKanbanList[i].equipmentStatus = '试模'
                    // }

                    if (this.productionKanbanList[i].inspectionStatus == 1) {
                        this.productionKanbanList[i].inspectionStatus = '✅'
                    } else {
                        this.productionKanbanList[i].inspectionStatus = ''
                    }

                }

            })
        },
        toFloat3(val) {
            // console.log('toFloat2')
            // console.log(val.toFixed(3))
            // console.log(val.toFixed(3)*100)
            if (isNaN(val)) {
                val = 0
            }

            return parseFloat((val.toFixed(3) * 100).toFixed(10))
        },
        fullScreen() {
            // console.log('fullScreen')
            let element = this.$refs.kanban
            // console.log(element)

            if (this.fullscreen) {
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                }
            } else {
                if (element.requestFullscreen) {
                    element.requestFullscreen();
                } else if (element.webkitRequestFullScreen) {
                    element.webkitRequestFullScreen();
                } else if (element.mozRequestFullScreen) {
                    element.mozRequestFullScreen();
                } else if (element.msRequestFullscreen) {
                    element.msRequestFullscreen();
                }
            }
            this.fullscreen = !this.fullscreen;
        },
        pageClick(currentPage) {
            this.purchaseKanbanList = []

            this.pageIndex = (currentPage - 1) * this.pageNum
            this.getAll()
        },
        handleSizeChange(val) {
            // console.log(`每页 ${val} 条`);
            this.pageNum = val

            this.getAll()
        },
    },
    mounted() {

        let url = window.location.href
        // console.log('url')
        // console.log(url)

        let str = url.substring(url.indexOf('?') + 1)
        let arrs = str.split('&')
        let result = {}

        arrs.forEach(item => {
            let keyArr = item.split('=')
            let name = keyArr[0]
            let value = keyArr[1]
            result[name] = value
        })

        if (Object.keys(result).length >= 1) {
            
            this.companyId = result.cid
            this.pageIndex = result.p * this.pageNum
        }

        this.getAll()

        this.$axios({
            method: "post",
            url: "/shiro/company/getKb",
            data: {
                id: this.companyId
            },
            headers: {}
        }).then(result => {
            
            this.companyName = result.data.data.companyName
        })

        setInterval(() => {
            
            this.getAll()
        }, 20000)

    },
    updated() {
        var ele = document.getElementsByClassName('el-progress-bar__inner')

        // console.log('upp')
        // console.log(ele)
        for (let i in ele) {
            var str = ele[i].attributes.style.value
            // console.log(str)
            var s = str.indexOf(':')
            var e = str.indexOf('%')

            var w = str.substring(s + 1, e)
            // console.log('---')
            // console.log(s)
            if (parseInt(w) > 100) {
                // console.log('>100')
                ele[i].attributes.style.value = 'width:100%'
            }
        }

    }
}
</script>

<style>
.kanban-container {
    width: 100%;
    height: 600px;
    background-color: #06207D;
    box-shadow: 0px 10px 10px 0px rgba(0, 0, 0, 0.5);
    border-radius: 5px;
    position: relative;
}

.production-kb-header {
    font-size: 25px;
    font-weight: bolder;
    color: white;
    line-height: 60px;
}

.kb-table {
    width: 1000px;
    table-layout: fixed;
    border: 1px solid white;
    font-size: 13px;
    font-weight: bold;
    color: white;
    border-collapse: collapse;
    border-spacing: 1px;
}

.kanban-tr-odd {
    font-size: 9px;
    color: black;
    background-color: white;
}

.kanban-tr {
    font-size: 9px;
    color: black;
    background-color: greenyellow;
}

.kb-table td {
    border: 1px solid #e5e7eb;
    padding: 0;
}

.kanban-td-o {
    background-color: orange;
}

.kanban-td-g {
    background-color: green;
}

.kanban-td-r {
    background-color: red;
}

.kanban-td-y {
    background-color: yellow;
    color: black;
}

.kanban-tr-odd td,
.kanban-tr td {
    border: 1px solid black;
}

div::-webkit-scrollbar {
    background: #6f5499;
    border-radius: 10px;
    width: 10px;
    height: 10px;
}

div::-webkit-scrollbar-thumb {
    background: orange;
    border-radius: 10px;

}

.el-pagination__total {
    color: pink;
}
</style>